import React, { Component } from 'react';
import MaterialTable from 'material-table';
import firebase from '../../firebase'
import CircularProgress from "@material-ui/core/CircularProgress";

import { forwardRef } from 'react';

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Delete from '@material-ui/icons/Delete'

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <Delete {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};



class Users extends Component {

    constructor(props) {
        super(props)

        this.state = {
            columns: [
                {
                    field: 'name',
                    title: 'Name',
                    grouping: false,
                },
                {
                    field: 'email',
                    title: 'Email',
                    minWidth: 150,
                    sorting: false,
                    grouping: false,
                },
                {
                    field: 'phoneNumber',
                    title: 'Phone',
                    sorting: false,
                    render: rowData => <a href={"tel:" + rowData.phoneNumber}>{rowData.phoneNumber}</a>,
                    grouping: false,
                },
                {
                    field: 'address',
                    title: 'Address',
                    sorting: false,
                    grouping: false,
                },
                {
                    field: 'orders',
                    title: 'Total Orders',
                    grouping: false,
                    align: 'right',
                    render: rowData => rowData.orders ? Object.keys(rowData.orders).length : 0
                }
            ],
            data: [],
            loading: true
        }

        this.database = firebase.database().ref().child('users')

    }

    componentDidMount() {


        let newItems = false

        this.database.on('value', snap => {
            newItems = true
            const myMap = snap.val()
                this.setState((prevState) => {
                    const data = [...prevState.data];
                    for (const [key, value] of Object.entries(myMap)) {
                        var offer = value
                        offer.key = key
                        data.push(offer);
                    }
                    return { ...prevState, data, loading: false };
                });

            
        })

        // this.database.on('child_added', snap => {
        //     if (!newItems) { return }
        //     this.setState((prevState) => {
        //         const data = [...prevState.data];
        //         var offer = snap.val()
        //         offer.key = snap.key
        //         data.push(offer);
        //         return { ...prevState, data, loading: false };
        //     });
        // })

        // this.database.on('child_removed', snap => {
        //     this.setState((prevState) => {
        //         const data = [...prevState.data];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].key === snap.key) {
        //                 data.splice(i, 1);
        //                 break;
        //             }
        //         }
        //         return { ...prevState, data };
        //     });

        // })

        // this.database.on('child_changed', snap => {
        //     this.setState((prevState) => {
        //         const data = [...prevState.data];
        //         for (var i = 0; i < data.length; i++) {
        //             if (data[i].key === snap.key) {
        //                 var offer = snap.val()
        //                 offer.key = snap.key
        //                 data.splice(i, 1, offer);
        //                 break;
        //             }
        //         }
        //         return { ...prevState, data };
        //     });
        //     this.forceUpdate()
        // })

    }

    updateOffer = async (newOffer, oldOffer) => {
        this.database.child(newOffer.key).update(newOffer)
    }

    deleteOffer = (offer) => {
        this.database.child(offer.key).remove().then(
            console.log("successfully deleted")
        ).catch(
            console.log("error in deleting")
        )
    }

    addOffer = async (offer) => {
        console.log(offer)
        this.database.push(offer)
    }

    render() {
        const { columns, data, loading } = this.state
        console.log(data)
        return (
            loading ? < CircularProgress style={{ position: "fixed", top: "50%", left: "50%" }}></CircularProgress> :
                <MaterialTable
                    title="Users"
                    columns={columns}
                    data={data}
                    icons={tableIcons}
                />
        )
    }
}

export default Users

// import React, { Component, Fragment } from 'react'
// import { Paper, withStyles, CircularProgress} from "@material-ui/core";
// import firebase from '../../firebase'

// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TablePagination from '@material-ui/core/TablePagination';
// import TableRow from '@material-ui/core/TableRow';

// const columns = [
//     {
//         id: 'name',
//         label: 'Name',
//         minWidth: 150
//     },
//     {
//         id: 'email',
//         label: 'Email',
//         minWidth: 150
//     },
//     {
//         id: 'phoneNumber',
//         label: 'Phone',
//         minWidth: 150,
//         format: (value) => <a href={"tel:" + value}>{value}</a>
//     },
//     {
//         id: 'address',
//         label: 'Address',
//         minWidth: 150,
//     },
//     {
//         id: 'orders',
//         label: 'Total Orders',
//         minWidth: 170,
//         align: 'right',
//         format: (value) => value ? Object.keys(value).length : 0
//     }
// ];



// const styles = theme => ({
//     paper: {
//         padding: 20,
//         // margin: theme.spacing(2),
//         // height: 500,
//         overflowY: 'auto'
//     },
//     root: {
//         width: '100%',
//         backgroundColor: theme.palette.background.paper,
//     },
//     nested: {
//         paddingLeft: theme.spacing(4),
//     },
//     container: {
//         maxHeight: 440,
//     },
// })

// class Users extends Component {

//     constructor(props) {
//         super(props)

//         this.state = {
//             users: [],
//             loading: true,
//             page: 0,
//             rowsPerPage: 10
//         }

//         this.database = firebase.database().ref().child('users')
//     }

//     handleChangePage = (event, newPage) => {
//         this.setState({
//             page: newPage
//         })
//     };

//     handleChangeRowsPerPage = (event) => {
//         this.setState({
//             rowsPerPage: +event.target.value,
//             page: 0
//         })
//     };

//     componentDidMount() {

//         const prevUsers = this.state.users

//         this.database.on('child_added', snap => {
//             prevUsers.unshift(snap.val())
//             prevUsers[0].id = snap.key;
//             this.setState({
//                 loading: false,
//                 users: prevUsers
//             })

//             this.forceUpdate()
//         })

//         this.database.on('child_removed', snap => {
//             for (var i = 0; i < prevUsers.length; i++) {
//                 if (prevUsers[i].order_id === snap.key) {
//                     prevUsers.splice(i, 1);
//                     break;
//                 }
//             }

//             this.setState({
//                 users: prevUsers
//             })

//         })

//         this.database.on('child_changed', snap => {

//             for (var i = 0; i < prevUsers.length; i++) {
//                 if (prevUsers[i].order_id === snap.key) {
//                     prevUsers.splice(i, 1, snap.val());
//                     prevUsers[i].id = snap.key;
//                     break;
//                 }
//             }

//             this.setState({
//                 users: prevUsers
//             })

//             this.forceUpdate()

//         })

//     }

//     updateOrdersData = async (id, data, uid) => {
//         console.log(data)
//         console.log(id)
//         console.log(uid)

//         this.database.child(id).update(data)
//         firebase.database().ref().child('users').child(uid).child('orders').child(id).update(data)

//         const userSnapshot = await firebase.database().ref("users").child(uid).once("value");
//         const { fcm, email } = userSnapshot.val();

//         console.log(fcm)
//         console.log(email)
//     }

//     getProcessedOrders() {
//         return this.state.orders.filter((order) => {
//             return order.payment === "COD" || order.payment === "Completed"
//         })
//     }

//     handleItemClick = (item) => {
//         console.log(item)
//         this.setState({
//             name: item.name
//         })
//     }

//     handleDeleteItemClick = (itemId) => {

//         this.database.child(itemId).remove().then(
//             console.log("successfully deleted")
//         ).catch(
//             console.log("error in deleting")
//         )
//     }


//     render() {
//         const { users, page, rowsPerPage } = this.state
//         const { classes } = this.props

//         return (
//             <Fragment>
//                 {this.state.loading ? < CircularProgress style={{ position: "fixed", top: "50%", left: "50%" }}></CircularProgress>
//                     :
//                     <Paper className={classes.root}>
//                         <TableContainer className={classes.container}>
//                             <Table stickyHeader aria-label="sticky table">
//                                 <TableHead>
//                                     <TableRow>
//                                         {columns.map((column) => (
//                                             <TableCell
//                                                 key={column.id}
//                                                 align={column.align}
//                                                 style={{ minWidth: column.minWidth }}
//                                             >
//                                                 {column.label}
//                                             </TableCell>
//                                         ))}
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     {users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((user) => {
//                                         return (
//                                             <TableRow hover role="checkbox" tabIndex={-1} key={user.id}>
//                                                 {columns.map((column) => {
//                                                     const value = user[column.id];
//                                                     return (
//                                                         <TableCell key={column.id} align={column.align}>
//                                                             {column.format ? column.format(value) : value}
//                                                         </TableCell>
//                                                     );
//                                                 })}
//                                             </TableRow>
//                                         );
//                                     })}
//                                 </TableBody>
//                             </Table>
//                         </TableContainer>
//                         <TablePagination
//                             rowsPerPageOptions={[10, 25, 100]}
//                             component="div"
//                             count={users.length}
//                             rowsPerPage={rowsPerPage}
//                             page={page}
//                             onChangePage={this.handleChangePage}
//                             onChangeRowsPerPage={this.handleChangeRowsPerPage}
//                         />
//                     </Paper>
//                 }
//             </Fragment>
//         )
//     }
// }

// export default withStyles(styles)(Users)


